import type {
    ProviderId} from "@@/shared/providers/provider-id";
import {
    providerIdZodSchema,
} from "@@/shared/providers/provider-id";
import { z } from "zod";
import type {
    BookableOptionValueId} from "../../resource-reference-options/bookable-option-value-id";
import {
    bookableOptionValueIdZodSchema,
} from "../../resource-reference-options/bookable-option-value-id";
import type {
    ResourceReservationId} from "../../resources/resource-reservation-id";
import {
    resourceReservationIdZodSchema,
} from "../../resources/resource-reservation-id";
import type { ReservationId} from "../reservation-id";
import { reservationIdZodSchema } from "../reservation-id";

type ManifestCheckInCommand = {
    _type: "MANIFEST_CHECKIN_COMMAND";
    providerId: ProviderId;
    reservationId: ReservationId;
    resourceReservationId: ResourceReservationId;
    bookableOptionValueId: BookableOptionValueId;
    index: number;
    checkin: boolean;
};

const manifestCheckInCommandZodSchema: z.ZodSchema<ManifestCheckInCommand> =
    z.object({
        _type: z.literal("MANIFEST_CHECKIN_COMMAND"),
        providerId: providerIdZodSchema,
        reservationId: reservationIdZodSchema,
        resourceReservationId: resourceReservationIdZodSchema,
        bookableOptionValueId: bookableOptionValueIdZodSchema,
        index: z.number(),
        checkin: z.boolean(),
    });

export { manifestCheckInCommandZodSchema };
export type { ManifestCheckInCommand };
